// @ts-nocheck
/* eslint-disable */
import Filters from './filters/index';
import Form from './form';
import { Visualizer, fit, advUser, callAdv, setAdvUser } from './visualizer/index';
import Markers from './markers/index';
import PrintItem from './printitem';
import { getLoggerData, logSearchSelection, logSearchResult, logSearchResultList, logSuggestSearchSelection } from "./analytics";
import { setQuery, unsetQuery } from "~/state/search/state";
import { store } from "~/state/store";
import { addListener, removeListeners } from "~/lib/signals";
import { deferPromise } from "~/util/general";
import { logFixedCategories } from "./fixedsuggest/analytics";
import { saveHistory } from "~/util/providers/history";
import Content from '~/content';
import PromoHP from "~/promohp";
import { CONFIG } from '~/config';
import { _ } from "~/i18n";
import Scene from "~/scene";
import { isDetailActive } from '~/util/detail';
import Canonical from "~/canonical";
import { watch, watchMapset } from "~/state/util";
import { ROUTE_CONST } from "~/route/const";
import { node } from "~/util/dom";
import { setCoordinates } from "~/state/map/state";
import { setDimmLayer, setSaturation } from "~/util/layer-dimm-saturation";
import { openPropositionDialog } from "~/util/premium";
import Search from "~/lib/search";

Mapy.Search = class extends Content {
	_markers: Markers;

	constructor() {
		super();

		this._contentName = "search";

		if (Mapy.CUS.search?.searchLimitOnPage) {
			Mapy.Search.PAGE = parseInt(Mapy.CUS.search?.searchLimitOnPage);
		}

		this._form = new Form({
			// data { query }
			onFormSend: data => {
				if (!Mapy.getComponent("detail").isActive()) {
					logFixedCategories();
				}
				this.search({
					query: data.query,
					searchOrigin: "search",
				});
				Mapy.getComponent("history").save();
			},
			// data { query, fromHistory, listCategory, noCorr }
			onFormSearch: data => {
				this.search(data);
			},
			onFormClear: () => {
				this.clearAll();
				this.focus();
				Mapy.getComponent("history").save();
			},
			// data { savedQuery, actualQuery }
			onFormCheckChange: data => {
				/* pokud mam vysledek a zmenila se query, smazu vysledek */
				if (this.hasResults() && data.savedQuery != data.actualQuery) {
					this.disablePanelLoad = false;
					this.clearAll();
					Mapy.getComponent("history").save();
				}
			},
			// data { query, suggestData, results }
			onSuggest: data => {
				const { query, suggestData, results, resultsType } = data;
				// analytika pro suggest
				logSuggestSearchSelection(suggestData, results, resultsType, "search");
				// nastavime analytiku hledani
				this.setLoggerData(query, null, suggestData);
			},
			// data { query }
			onSuggestEnter: data => {
				if (!Mapy.getComponent("detail").isActive()) {
					logFixedCategories();
				}
				this.search({
					query: data.query,
					searchOrigin: "search",
				});
				Mapy.getComponent("history").save();
			},
			// data { title, query, fromTips, cat }
			onFixedSuggestSearch: data => {
				if (!Mapy.getComponent("detail").isActive()) {
					logFixedCategories();
				}
				this.setState({
					q: data.query,
					fromTips: data.fromTips,
					cat: data.cat,
					searchOrigin: "fixed_suggestion",
				});
				Mapy.getComponent("history").save();
			},
		});
		this._promohp = new PromoHP();

		this._dom = {
			container: node("div", { id: "search" }),
			fakeInput: node("input"),
			promo: this._promohp.getContainer(),
		};

		this._search = null;
		this._loggerData = null;
		this._logSearchList = false;
		this._visualizer = null;
		this._filters = null;
		this._markers = null;
		this._query = "";
		this._fromTips = false;
		this._fromHistory = false;
		this._onlyQueryInUrl = false;
		this._dom.fakeInput.style.display = "none";
		this._sc = [];
		this._corrLogData = null;
		this._logCorrection = false;
		this._noCorr = false;
		this._locCorrection = false;
		this._clearSavedCorrection();
		this._searchFilters = {};
		this._filtersDOTHit = {
			show: 0,
			use: {},
		};
		this._noResultAction = false;
		this._correction = null;
		this._disablePanelLoad = false;
		this._clearDisPan = false;
		this._detailOpening = false;
		this._memorycz = null;
		this._historyPage = 0;
		this._forceMarkersLoad = false;
		this._prevFullSearch = null;
		this._dimOf = [];
		this._panoActive = false;
		this._disableCenterZoom = false;

		addListener(this, "route-change", "_routeOverview");
		addListener(this, "search-abort", "_clearLoaders");
		addListener(this, "distancemeter-activated", () => {
			this.disablePanelLoad = false;
			Mapy.getComponent("pois").forceRequest();
		});
		addListener(this, "usermarks-activated", () => {
			this.disablePanelLoad = false;
			Mapy.getComponent("pois").forceRequest();
		});

		addListener(this, "pano-activate", () => {
			this._panoActive = true;
		});

		addListener(this, "pano-deactivate", () => {
			this._panoActive = false;
		});

		this._viewportGeometry = {
			layer: Scene.createLayerGeometry(),
			geometry: null,
			geometryB: null,
		};
	}

	destroy() {}

	set disablePanelLoad(disable) {
		this._disablePanelLoad = disable;

		if (!disable) {
			this._memorycz = null;
		}
	}

	set detailOpening(opening) {
		this._detailOpening = opening;
	}

	get detailOpening() {
		return this._detailOpening;
	}

	get forceMarkersLoad() {
		return this._forceMarkersLoad;
	}

	set mapSearch(ms) {
		this._mapSearch = ms;
	}

	set noResultAction(noAction) {
		this._noResultAction = noAction;
	}

	get correction() {
		return this._savedCorrection.correctorId !== 0 || this._locCorrection ? this._savedCorrection : this._search?.getCorrection();
	}

	get locCorrection() {
		return this._locCorrection;
	}

	rememberCenterZoom({ center, zoom }) {
		const page = this._search ? this._search.getPage() : 0;

		this._memorycz = {
			center,
			zoom,
			page,
		};
	}

	activate() {
		if (this.isActive()) {
			this.clearAll();
			this._loggerData = null;
			this._form.clear();
			this._form.getSearchTips().open();
			this._form.startOnboarding();
			this.focus();

			this.disablePanelLoad = false;

			return this;
		}

		super.activate();

		Mapy.getComponent("stateswitch").setState(this);

		this._routeOverview();
		this._setSEO();
		this._listenToOverlayItems(true);

		if (Mapy.active[0] === this && this._form.getSearchTips().isOpen()) {
			Mapy.getComponent("layout").getScrollNode().classList.add("fixed-suggest");
		}

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		if (Mapy.CUS.search?.searchViewport || Mapy.CUS.search?.searchViewportBackend) {
			Scene.addLayer(this._viewportGeometry.layer).enable();
		}

		this._markHaveResults(this.hasResults());

		setDimmLayer(true);

		const wt = watch(store.getState, "map", watchMapset);

		this._storeUnsubscribe = store.subscribe(wt(() => {
			this._markHaveResults(this.hasResults());
		}));

		Mapy.getComponent("pois").forceRequest();

		Mapy.CML.state = {
			route: {
				interaction: false,
			}
		};

		if (advUser && this._visualizer) {
			const { user } = store.getState().user;

			if (user.userPublicId !== advUser.userPublicId || user.state !== advUser.state) {
				setAdvUser({
					userPublicId: user.userPublicId,
					state: user.state,
				});

				callAdv(this._visualizer.getContainer(), this._visualizer);
			}
		}

		return this;
	}

	setLoggerData(query, search, suggestData) {
		if (!query) {
			query = this._form.getQuery();
		}

		this._loggerData = getLoggerData(query, search, suggestData);
	}

	get promoHP() {
		return this._promohp;
	}

	_setSEO() {
		if (this._query) {
			Mapy.SEO.set(
				this._listCategory ? this._query : _("search.seoQuery", this._query),
				_(this._listCategory ? "mapy.search.seoDescriptionQueryWithoutSearch" : "mapy.search.seoDescriptionQuery", this._query),
				_("search.seoKeywordsQuery")
			);
		} else {
			Mapy.SEO.set(
				_("search.seoTitle"),
				_("search.seoDescription"),
				_("search.seoKeywords")
			);
		}
	}

	deactivate() {
		super.deactivate();

		this.disablePanelLoad = false;

		this._listenToOverlayItems();
		Mapy.getComponent("layout").showBottomPart();
		this._form.endOnboarding();

		if (this._markers) {
			this._markers.stopListen();
			this._markers.deactivate();
		}

		Mapy.getComponent("layout").getScrollNode().classList.remove("fixed-suggest");

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		if (Mapy.CUS.search?.searchViewport || Mapy.CUS.search?.searchViewportBackend) {
			this._viewportGeometry.layer.disable();
			Scene.removeLayer(this._viewportGeometry.layer);
		}

		this._markHaveResults(false);

		setDimmLayer();

		removeListeners(this._dimOf);
		this._dimOf = [];
		this._storeUnsubscribe && this._storeUnsubscribe();

		Mapy.getComponent("pois").forceRequest();

		Mapy.CML.state = {
			route: {
				interaction: true,
			}
		};

		return this;
	}

	clearAll() {
		this.clearResults();

		Mapy.getComponent("pois").forceRequest();

		this.clearMarkers();
		this.clearVisualiser();
		this.clearFilters();
		this.destroyFilters();

		if (Mapy.CUS.search?.searchViewport || Mapy.CUS.search?.searchViewportBackend) {
			this._viewportGeometry.layer.removeAll();
			if (this._viewportGeometry.geometry) {
				this._viewportGeometry.geometry.destroy();
				this._viewportGeometry.geometry = null;
			}

			if (this._viewportGeometry.geometryB) {
				this._viewportGeometry.geometryB.destroy();
				this._viewportGeometry.geometryB = null;
			}
		}

		this._locCorrection = false;
		this._clearSavedCorrection();
	}

	clearResults(newSearch) {
		!newSearch && store.dispatch(unsetQuery());
		this._query = "";
		this._listCategory = 0;

		!newSearch && this._markHaveResults(false);

		if (this._search) {
			this._search.$destructor();
			this._search = null;
		}

		this._form.closeSuggest();
		this._form.clearSuggestItems();

		this._dom.fakeInput.remove();

		// vola vice instanci -> check, jestli jsme zobrazeni
		if (this.isActive() && Mapy.active.indexOf(this) == 0 && !this._mapSearch) {
			Mapy.getComponent("layout").showBottomPart(true);
			this._setSEO();
		}

		/* prohazovani stateswitche pro mala rozliseni */
		if(Mapy.Util.isSmallResolution() && Mapy.active[0] == this && Mapy.getComponent("layout").getWidth()!= 1 && !this._mapSearch){
			const bar = Mapy.getComponent("layout").getBar();

			Mapy.getComponent("layout").setBottomPanel(bar);
		}
	}

	clearFilters() {
		this._searchFilters = {};
		this.noResultAction = false;
		this._correction = null;

		this._filtersDOTHit = {
			show: 0,
			use: {},
		};
	}

	destroyFilters() {
		if (this._filters) {
			this._filters.destroy();
			this._filters = null;
		}
	}

	clearMarkers() {
		if (this._markers) {
			this._markers.destroy();
			this._markers = null;
		}
	}

	clearVisualiser() {
		if (this._visualizer) {
			this._visualizer.destroy();
			this._visualizer = null;
		}
	}

	hasResults() {
		if (this._search && "getResults" in this._search && this._search.getResults()) {
			return !!this._search.getResults().length;
		}
		return !!this._search;
	}

	getResults() {
		return (this._search ? this._search.getResults() : []);
	}

	getQuery() {
		return this._query;
	}

	getFilters() {
		return this._searchFilters;
	}

	getQueryType() {
		return this._search?.getQueryType() || "";
	}

	search(searchOpts) {
		const promiseData = deferPromise();

		if (searchOpts && this._query !== searchOpts.query) {
			this._disablePanelLoad = false;
		}

		// pro ukladani do url
		if (searchOpts?.query != "" ) {
			// FIXME: tady se nastavuje query a tedy by tu mela byt operace nad store, ale nechapu presne ten ucel, tak je to na budouci implementaci store v searchi
			//store.dispatch(setQuery(searchOpts?.query));
			this._query = searchOpts?.query;
		}

		const opts = Object.assign({
			query: "",
			fromHistory: false,
			listCategory: 0,
			noCorr: false,
			detailSearch: false,
			mapSearch: this._mapSearch,
		}, searchOpts);
		const { query, fromHistory, listCategory, noCorr, mapSearch } = opts;

		this.setLoggerData();
		this._form.focus();
		this._form.timeoutFocus(1000);

		if (this._disablePanelLoad) {
			this._doSearch(opts, promiseData);
			return;
		}
		else {
			this.disablePanelLoad = false;
		}

		this.clearResults(true);

		if (!query) {
			this._loggerData = null;
			Mapy.getComponent("layout").showBottomPart(true);
			return;
		}

		if (!mapSearch) {
			Mapy.getComponent("layout").showBottomPart();
		}

		store.dispatch(setQuery(query));
		this._query = query;
		this._form.setQuery(query);

		if (!this.isActive()) {
			this._form.setDefaultState();
		}

		this._listCategory = listCategory;
		this._fromHistory = fromHistory;
		this._noCorr = noCorr;

		this._doSearch(opts, promiseData);
		this._dom.promo.before(Mapy.getComponent("loader").getBigCon());
		Mapy.getComponent("loader").start(true);

		return promiseData.promise;
	}

	show() {
		if (Mapy.active[0] === this && this._form.getSearchTips().isOpen()) {
			Mapy.getComponent("layout").getScrollNode().classList.add("fixed-suggest");
		}

		if (this._fromHistory || !Mapy.Util.isSmallResolution()) {
			Mapy.getComponent("layout").setWidth(1);
		}

		this._dom.container.appendChild(this._form.getContainer());

		/* promo */
		Mapy.getComponent("layout").showBottomPart(!(this.hasResults()));

		if (this._visualizer) {
			this._dom.container.appendChild(this._visualizer.getContainer());

			if (this._filters) {
				this._visualizer.addFilterNode(this._filters.node);
			}
		}

		var content = super.show();

		this._setSEO();
		this._promohp.impress();

		if (Mapy.active[0] == this) {
			if (this._search) {
				var BPTitle = node("h4", {className:"bp-search"});
				BPTitle.appendChild(document.createTextNode(this._query));
				Mapy.getComponent("layout").setBottomPanel(BPTitle);
			} else {
				/* prohazovani stateswitche pro mala rozliseni */
				if(Mapy.Util.isSmallResolution() && Mapy.getComponent("layout").getWidth()!= 1){
					const bar = Mapy.getComponent("layout").getBar();

					Mapy.getComponent("layout").setBottomPanel(bar);
				}
			}
		}

		/* pokud je skryta vrstva s vysledky v mape zobrazim ji*/
		if (this._markers && (!this._markers.interaction || !this._markers.isActive)) {
			this._markers.startListen();
			this._markers.activate();

			// mohlo dojit k posunu mapy a proto zahledame radeji znovu, pokud se nejedna o nejakou akci
			if (!this._search?.getAction()) {
				if (this._panoActive) { // pokud se jedna o vypnuti pano, nechceme delat centerzoom na vysledky
					this._disableCenterZoom = true;
				}

				this.search({
					query: this._query,
					listCategory: this._listCategory,
				});
			}
		}

		this.focus();
		this._form.closeSuggest();

		if (!this._query && !this._search) {
			this._form.getSearchTips().open();
			this._form.startOnboarding();
		}

		// promo
		this._dom.container.appendChild(this._dom.promo);
		Mapy.CML.state = {
			route: {
				showGeometries: true,
			}
		};

		if (this._disablePanelLoad) {
			this._forceMarkersLoad = true;

			if (this._memorycz) {
				const [longitude, latitude] = this._memorycz.center.toWGS84();
				const { zoom } = store.getState().map;

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: this._memorycz.zoom,
					animate: !CONFIG.inFrame && this._memorycz.zoom >= zoom - 1 && this._memorycz.zoom <= zoom + 1,
				}));
			}

			this._clearDisPan = true;
		}

		this._markHaveResults(this.hasResults());
		Mapy.getComponent("pois").forceRequest();

		return content;
	}

	suggestSend() {
		this._form.sendSuggest();
	}

	focus() {
		this._form.focus();
	}

	timeoutFocus() {
		this._form.timeoutFocus();
	}

	getFormWidth() {
		return this._form.width;
	}

	hide() {
		Mapy.getComponent("layout").getScrollNode().classList.remove("fixed-suggest");
		Mapy.getComponent("layout").showBottomPart();
		this._form.endOnboarding();

		Mapy.CML.state = {
			route: {
				showGeometries: false,
			}
		};

		this._markHaveResults(false);

		return super.hide();
	}

	getContainer() {
		return this._form.getContainer();
	}

	handleEvent(e) {
		if (e.type == "photo-detail-close" || e.type == "photo-gallery-close") {
			this.isActive() && !Mapy.getComponent("gallery").isActive() && this._setSEO();
		}
	}

	_getOptions(optsArg) {
		const { viewport, page, listCategory, noCorr, searchFilters, correction, mapSearch } = optsArg;
		const { zoom } = store.getState().map;
		const options = {
			listCategory,
			noCorr,
			zoom,
			viewport,
			page,
			pageSize: Mapy.Search.PAGE,
			limit: parseInt(Mapy.CUS.search?.searchLimit || 200),
		};

		let filters = [];

		if (Object.keys(searchFilters).length) {
			for (let name in searchFilters) {
				filters.push(searchFilters[name]);
			}

			options.filters = filters;
		}

		if (correction) {
			options.correction = {
				correctedQuery: correction.correctedQuery,
				status: correction.status,
				shouldQuery: correction.shouldQuery,
				correctorId: correction.correctorId,
			}
		}

		if (mapSearch) {
			options.filter = true;
			options.filterMultimarker = SMap.WMMarker.getFilterMultimarker();
			options.limit = parseInt(Mapy.CUS.search?.searchLimit || 200);
		}

		return options;
	}

	_getViewport() {
		const viewport = Scene.getViewport();
		let lb = Scene.coordsFromWGS84(viewport.lbx, viewport.lby);
		let rt = Scene.coordsFromWGS84(viewport.rtx, viewport.rty);

		if (!Mapy.Util.isSmallResolution() && !Scene.isM3dActive()) {
			const padding = store.getState().map.padding;

			//odecet paddingu mapy
			const lbPixel = Scene.coordsToPixel(lb).minus({ x:  -Mapy.CUS.userweb?.searchViewportTop || -padding.left, y: Mapy.CUS.userweb?.searchViewportBottom || padding.bottom});
			const rtPixel = Scene.coordsToPixel(rt).minus({ x:  Mapy.CUS.userweb?.searchViewportRight || padding.right, y: -Mapy.CUS.userweb?.searchViewportTop || -padding.top});
			lb = Scene.pixelToCoords(lbPixel);
			rt = Scene.pixelToCoords(rtPixel);
		}

		return [lb, rt];
	}

	_getPage() {
		let page = 0;

		if (this._fromHistory && this._historyPage) {
			page = this._historyPage;
		} else if (this._clearDisPan && this._memorycz?.page) {
			page = this._memorycz.page;
		}

		return page;
	}

	/**
	 * "Opravdove" zahledani (az pote, co jsou ready poiservery)
	 */
	_doSearch(opts, promiseData) {
		const viewport = this._getViewport();
		const page = this._getPage();

		if (Mapy.CUS.search?.searchViewport) {
			const [lb, rt] = viewport;
			const coords = [
				Scene.coordsFromWGS84(lb.x, lb.y),
				Scene.coordsFromWGS84(lb.x, rt.y),
				Scene.coordsFromWGS84(rt.x, rt.y),
				Scene.coordsFromWGS84(rt.x, lb.y),
				Scene.coordsFromWGS84(lb.x, lb.y)
			];

			this._viewportGeometry.layer.removeAll();

			this._viewportGeometry.geometry = Scene.createGeometry(Scene.GEOMETRY.POLYGON, "vpsearch-more", coords, {
					width: 6,
					opacity: 0.2,
					outlineOpacity: 0.5,
			});
			this._viewportGeometry.layer.addGeometry(this._viewportGeometry.geometry);
		}

		const correction = this._noResultAction && this._correction?.status !== "nocorr" ? this._correction : null;

		this._correction = null;
		this._logSearchList = true;

		if (this._prevFullSearch && this._disablePanelLoad && !isDetailActive(store.getState())) {
			if (this._search) {
				this._search.abort(this._prevFullSearch === this._search);

				if (this._markers) {
					this._markers.clearSearchTimeout();
				}
			}
			this._search = this._prevFullSearch;
			this._searchDone(this._search, promiseData, opts);
		}
		else {
			const options = this._getOptions({
				viewport,
				page,
				listCategory: this._listCategory,
				noCorr: this._noCorr,
				searchFilters: this._searchFilters,
				correction,
				mapSearch: this._mapSearch
			});

			this._form.focus();
			this._search = new Search(this._query, options);
			this._search.search((search, origin) => {
				this._searchDone(search, promiseData, opts, origin);
			});
		}

		if (!this._disablePanelLoad) {
			this._prevFullSearch = this._search;
		}
	}

	async _searchDone(search, promiseData, opts, origin = "") {
		let mapSearch = opts.mapSearch;

		// zrusime filtry
		this.destroyFilters();
		if (!this._disablePanelLoad) {
			this.clearVisualiser();

			this._visualizer = new Visualizer();
			this._dom.promo.before(this._visualizer.getContainer());
		}

		this._historyPage = 0;

		Mapy.getComponent("loader").start();
		this._clearLoaders();

		if (!this.isActive() || !this._visualizer) {
			promiseData.resolve({
				type: "none"
			});
			return;
		}

		this._logCorrection = false;
		let centerZoomProm = Promise.resolve();
		let origAction = search.getAction();
		let action = origAction;
		let filters = search.getFilters();
		this._markers && this._markers.stopListen();

		if (this._noResultAction) {
			action = null;
			this.noResultAction = false;
		}

		const isDetail = action && action.type === "detail" && action.immediate;

		if (search.descriptionStatus.toString().charAt(0) == "2" && Mapy.active.length && (!mapSearch && !this._disablePanelLoad) && (Mapy.active[0] == this || opts.detailSearch) && origAction?.type !== "detail") {
			var results = search.getResults();

			/* neni z historie - neco udelat */
			if (!opts.detailSearch && (!this._fromHistory || this._onlyQueryInUrl) && !isDetail && results.length >= 1 && !this._disableCenterZoom) {
				centerZoomProm = fit(search.getMeta());
			}
		}

		this._disableCenterZoom = false;

		const sMeta = search.getMeta();

		if (Mapy.CUS.search?.searchViewportBackend && sMeta?.queryLoc?.bbox) {
			const coords = [
				Scene.coordsFromWGS84(sMeta.queryLoc.bbox.leftLon, sMeta.queryLoc.bbox.leftLat),
				Scene.coordsFromWGS84(sMeta.queryLoc.bbox.leftLon, sMeta.queryLoc.bbox.rightLat),
				Scene.coordsFromWGS84(sMeta.queryLoc.bbox.rightLon, sMeta.queryLoc.bbox.rightLat),
				Scene.coordsFromWGS84(sMeta.queryLoc.bbox.rightLon, sMeta.queryLoc.bbox.leftLat),
				Scene.coordsFromWGS84(sMeta.queryLoc.bbox.leftLon, sMeta.queryLoc.bbox.leftLat)
			];

			this._viewportGeometry.geometryB = Scene.createGeometry(Scene.GEOMETRY.POLYGON, "vpsearchB-more", coords, {
					width: 6,
					opacity: 0.2,
					outlineOpacity: 0.5,
					color: "#0f0",
					outlineColor: "#0f0",
			});
			this._viewportGeometry.layer.addGeometry(this._viewportGeometry.geometryB);
		}

		let corr = search.getCorrection();

		if (corr.correctorId === 0 && this._savedCorrection) {
			corr = this._savedCorrection;
		}

		if (corr.correctorId === 10) {
			this._form.setQuery(corr.correctedQuery);
			store.dispatch(setQuery(corr.correctedQuery));
			this._query = corr.correctedQuery;
			this._savedCorrection = corr;
		}

		// query pro analytiku
		let query = this._query.trim().toLowerCase();
		const isNotDetail = !action || (action && action.type != "detail");

		// nastaveni search formu
		this._form.setSearchState(query);
		this._form.closeSuggest();
		this._form.focus();

		if (search.resultStatus.toString().charAt(0) == "2") {
			!this._mapSearch && Mapy.getComponent("pois").forceRequest();

			if (!this._disablePanelLoad) {
				if (CONFIG.isScreenshoter) {
					this._visualizer?.load(search, mapSearch, origin);
				} else {
					requestAnimationFrame(() => {
						this._visualizer?.load(search, mapSearch, origin);
					});
				}
			}

			const bpAndSEO = () => {
				if (Mapy.active[0] == this) {
					var BPTitle = node("h4", {className:"bp-search"});
					BPTitle.appendChild(document.createTextNode(this._query));
					Mapy.getComponent("layout").setBottomPanel(BPTitle);
					if (!isDetailActive(store.getState())) { this._setSEO(); }
				}
			}

			if (CONFIG.isScreenshoter) {
				bpAndSEO();
			} else {
				requestAnimationFrame(() => {
					bpAndSEO();
				});
			}

			var allResults = search.getAllResults();
			var resultsLen = allResults.length;

			if (corr.status && corr.status !== "nocorr") {
				this._correction = corr;
			}

			this._markHaveResults(!!((!action || action && this._mapSearch) && resultsLen));

			// search results analytika
			const source_input = this._fromHistory ? "url" : this._form.sourceInput;

			// pokud se podle BE ma otevrit detail, ale my to nebudeme delat, tak akci neposilame
			if (!opts.detailSearch) {
				this._action = null;
			}
			logSearchResult(query, source_input, search, this._searchFilters, origin || opts.searchOrigin || "");

			if (resultsLen && this._logSearchList && !isDetailActive(store.getState())) {
				logSearchResultList(search, this._searchFilters);
			}

			this._logSearchList = false;

			if (!this._markers && resultsLen) { /* jen pokud jeste nebyly - tak, aby se znovu nevyrobily pri prestrankovani */
				this._markers = new Markers(search, this._fromHistory, {
					redrawCb: () => {
						// signal pro nove hledani z mapy
						this._mapSearch = true;

						return this.search({
							query: this._query,
							listCategory: this._listCategory,
							searchOrigin: "map_shift",
						});
					},
					markerStateCb: data => {
						this._visualizer?.hoverItem(data);
					},
				});
				if (!isDetail && !(isDetailActive(store.getState()) && Mapy.Search.hideResults())){
					this._markers.activate();
				}
			}
			else if (resultsLen === 0) {
				Mapy.setPhantomMeta(404);
			}

			// nastavime markerum data -> pouze pokud byly jiz vytvorene
			this._markers?.setSearch(search);

			centerZoomProm.then(() => {
				if (this._markers?.isActive) {
					this._markers?.startListen(true);
				}
			}, () => {});

			// filtry
			if (filters && !this._filters) {
				if (CONFIG.isScreenshoter) {
					this._setFilters(filters);
				} else {
					requestAnimationFrame(() => {
						this._setFilters(filters);
					});
				}
			}
		} else if (search.resultStatus.toString().charAt(0) === "4") {
			this._visualizer.showNoResultsError();
			Mapy.setPhantomMeta(search.resultStatus);
		} else if (!action) {
			this._visualizer.showErrorMsg("repeat", true);
			Mapy.setPhantomMeta(404);
		}

		// existuje oprava preklepu
		if ("status" in corr && corr.status !== "nocorr" && corr.correctedQuery !== "") {
			this._corrLogData = {
				q: query,
				text: corr.correctedQuery.toLowerCase(),
				lang: CONFIG.defaultLang,
				type: corr.correctorId,
			};
			// zalogujeme, az jestli nekdy uzivatel zavre detail a pritom jeste bude zahledano
			if (isDetail || isDetailActive(store.getState())) {
				this._logCorrection = true;
			// uzivatel videl opravu preklepu hned
			} else {
				Mapy.getComponent("logger").log("correction", this._corrLogData);
			}

			if (isNotDetail) {
				let hData = {
					title: corr.correctedQuery,
					source: "web",
					type: this._listCategory ? "category" : "query",
				}

				if (!this._listCategory) {
					hData.data = {
						lang: search.getMeta().detectedQueryLanguage,
					};
				}

				const { user } = store.getState().user;

				!mapSearch && !opts.detailSearch && saveHistory(user, hData);
			}
		}
		else if (resultsLen || this._listCategory || (action && action.type != "detail")) {
			if (isNotDetail) {
				let hData = {
					title: this.getQuery().trim(),
					source: "web",
					type: this._listCategory || search.getMeta().hasCategory ? "category" : "query",
				};

				if (!(this._listCategory || search.getMeta().hasCategory)) {
					hData.data = {
						lang: search.getMeta().detectedQueryLanguage,
					};
				}

				const { user } = store.getState().user;

				!mapSearch && !opts.detailSearch && saveHistory(user, hData);
			}
		}

		// immediate == false zatim nechodi, ale po dohode s Jirkou Vrbou kdyby bylo, tak takovou akci ignorujeme
		let wasHandled = false;

		if (action && action.immediate) {
			wasHandled = await this._handleAction(search, promiseData, opts, mapSearch, query);
		}

		if (!wasHandled && this._loggerData) {
			this.setLoggerData(undefined, search);

			if (!this._fromTips && (this._loggerData.exact || action) && !mapSearch) {
				logSearchSelection(query, search, this._loggerData, opts.detailSearch);
			}
			else {
				this._fromTips = false;
			}
		}

		// musime resetovat sourceInput
		if (this._form.sourceInput === "onboarding") {
			this._form.resetSourceInput();
		}

		this._fromHistory = false;
		this._onlyQueryInUrl = false;
		this._mapSearch = false;

		if (this._clearDisPan) {
			this.disablePanelLoad = false;
			this._clearDisPan = false;
			this._forceMarkersLoad = false;
			this._prevFullSearch = null;
		}

		if (!wasHandled) {
			promiseData.resolve({
				type: "search"
			});
		}

		Mapy.getComponent("loader").end();
	}

	getState() {
		const page = this._search ? this._search.getPage()+1 : 0;
		let state = {};

		if (this._query) { state.q = this._query; }
		if (this._listCategory) { state.cat = 1; }

		if (Object.keys(this._searchFilters).length) {
			state.sf = "";

			for (let name in this._searchFilters) {
				state.sf += `${state.sf !== "" ? `|` : ``}${this._searchFilters[name].type}:${this._searchFilters[name].id}`;
			}
		}

		if (page > 1 && !this._disablePanelLoad) {
			state.pg = page;
		}
		else if (Mapy.active[0] === this && this._memorycz?.page) {
			state.pg = this._memorycz.page+1;
		}

		return state;
	}

	setState(data) {
		if (data.q == this._query) { return this; }

		if (!data.q) {
			this._disablePanelLoad = false;
		}

		if (CONFIG.inFrame && data.source && data.id) {
			return this;
		}

		var fromHistory = Mapy.getComponent("history").isFromHistory();
		this._onlyQueryInUrl = !data.x && !data.y;

		this.clearAll();
		if (data.q && typeof data.q === "string") {
			store.dispatch(setQuery(data.q));
		} else {
			store.dispatch(unsetQuery());
		}
		this._query = data.q || "";
		this._loggerData = null;

		this._form.setQuery(this._query);

		if (Mapy.getComponent("history").isFromHistory()) {
			this._loggerData = getLoggerData(this._query);
		}

		if (data.sf) {
			let filters = data.sf.split("|");

			if (filters.length) {
				filters.forEach(f => {
					let filter = f.split(":");

					if (filter.length > 1) {
						this._searchFilters[filter[0] === "filter" ? filter[1] : filter[0]] = {
							id: filter[1],
							type: filter[0],
						};
					}
				});
			}
		}

		if (data.fromTips) {
			this._fromTips = true;
			this._loggerData = getLoggerData(this._query);
		}

		if (this._query) {
			var listCategory = 0;

			if ("cat" in data) {
				listCategory = parseFloat(data.cat);
			}

			if (data.pg && parseInt(data.pg)) {
				this._historyPage = parseInt(data.pg)-1;
			}

			this.search({
				query: this._query,
				fromHistory,
				listCategory,
				detailSearch: data.detailSearch,
				searchOrigin: data.searchOrigin || "",
			});
		}

		return this;
	}

	hoverItem(data) {
		this._visualizer?.hoverItem(data);
	}

	_routeOverview() {
		if (!this.isActive()) { return; }
		var route = Mapy.getComponent("route");

		var routeOverview = route.getRouteOverview(true); // zjisteni informaci od geometrie
		if (routeOverview) {
			this._dom.container.insertBefore(routeOverview, this._dom.container.firstChild);
		}
		else {
			this._dom.container.querySelector("#route-results")?.remove();
		}
	}

	_clearLoaders() {
		Mapy.getComponent("loader").end(true);

		var loaderCon = Mapy.getComponent("loader").getBigCon();
		if (loaderCon.parentNode == this._dom.container) {
			loaderCon.remove();
		}
	}

	setCorrection(correctedQuery) {
		this._form.setQuery(correctedQuery);
		let noCorr = true;

		this._locCorrection = true;

		if (this._savedCorrection.correctorId === 10) {
			this._clearSavedCorrection();
			store.dispatch(setQuery(correctedQuery));
			this._query = correctedQuery;
			noCorr = false;
		}

		// zrusime dalsi korekce
		this.search({
			query: correctedQuery,
			noCorr,
			searchOrigin: "correction",
		});
	}

	getMarkers() {
		return this._markers;
	}

	_detailActivated() {
		Mapy.getComponent("pois").forceRequest();

		if (this._markers && Mapy.Search.hideResults() && !this._markers.disable) {
			this._markers.stopListen();
			this._markers.deactivate();
		}
	}

	_detailDeactivated() {
		Mapy.getComponent("pois").forceRequest();

		if (this._markers) {
			this._markers.startListen();
			this._markers.activate();
		}

		Mapy.CML.state = {
			route: {
				showGeometries: true
			}
		};

		if (this._logCorrection) {
			Mapy.getComponent("logger").log("correction", this._corrLogData);
			this._logCorrection = false;
		}

		Canonical.remove();
		Canonical.setByPage();
	}

	_listenToOverlayItems(listen) {
		if (listen) {
			if (this._sc.length) {
				removeListeners(this._sc);
				this._sc = [];
			}

			this._sc.push(addListener(this, "detail-activated", "_detailActivated"));
			this._sc.push(addListener(this, "detail-deactivated", "_detailDeactivated"));
		}
		else {
			if (this._sc.length) {
				removeListeners(this._sc);
				this._sc = [];
			}
		}
	}

	_setFilters(filters) {
		// filtry
		if (!this._filtersDOTHit.show) { // analytika zobrazeni se posila jen jednou za session
			let type = [];

			filters.forEach(f => {
				type.push(f.type === "filter" ? f.id : f.type);
			});

			Mapy.getComponent("logger").log("search_filters_show", {
				type: type.join(","),
			});

			this._filtersDOTHit.show = 1;

			if (this._fromHistory) {
				let fk = Object.keys(this._searchFilters);

				fk.forEach(f => {
					if (!this._filtersDOTHit.use[f]) {
						Mapy.getComponent("logger").log("search_filters_use", {
							type: f,
						});

						this._filtersDOTHit.use[f] = 1;
					}
				});
			}
		}

		this._filters = new Filters(filters, this._searchFilters);
		this._filters.cb = change => {
			if (change.on) {
				this._searchFilters[change.name] = {
					type: change.type,
					id: change.id,
				}

				if (!this._filtersDOTHit.use[change.name]) {  // analytika pouziti se posila jen jednou za session
					Mapy.getComponent("logger").log("search_filters_use", {
						type: change.name,
					});

					this._filtersDOTHit.use[change.name] = 1;
				}
			}
			else {
				delete this._searchFilters[change.name];
			}

			this.noResultAction = true;

			this._mapSearch = true;

			this.search({
				query: this._query,
				fromHistory: this._fromHistory,
				listCategory: this._listCategory,
				noCorr: this._noCorr,
				searchOrigin: "filter_results",
			});
			Mapy.getComponent("history").save();
		};

		this._visualizer?.addFilterNode(this._filters.node);
	}

	async _handleAction(search, promiseData, opts, mapSearch, query) {
		const action = search.getAction();
		const allResults = search.getAllResults();
		let wasHandled = false;

		switch (action.type) {
			case "route":
				let items = [];
				let num = 0;

				action.args.pois.forEach(i => {
					if (i.id > 0) {
						items.push({
							id: i.id,
							source: i.source,
							geometry: Scene.coordsToString([Scene.coordsFromWGS84(i.coords[0], i.coords[1])]),
							title: i.title,
							desc: i.subtitle,
							position: num,
						});
					}

					num++;
				});
				wasHandled = true;
				if (this._loggerData) {
					this.setLoggerData(undefined, search);

					if (!this._fromTips && (this._loggerData.exact || action) && !mapSearch) {
						logSearchSelection(query, search, this._loggerData, opts.detailSearch);
					} else {
						this._fromTips = false;
					}
				}
				promiseData.resolve({
					type: "route"
				});
				await Mapy.getComponent("route").activate();
				Mapy.CML.state = {
					route: {
						items,
						zoom: true,
						params: {
							criterion: ROUTE_CONST.types.car.def,
							useTraffic: !!action.args?.params?.rut,
							...action.args?.params ? action.args.params : {},
						},
					}
				};
				Mapy.getComponent("history").save();
				break;
			case "url":
				try {
					// tohle nas v IE11 vyhodi ven a to chceme
					const url = new URL(action.args.url);
					const { user } = store.getState().user;

					saveHistory(user, {
						title: action.args.url,
						source: "web",
						type: "query",
					}).then(() => {}, () => {});

					wasHandled = true;
					// pokud to bude zkracena, tak synchronne nedovedeme vedet, co je zac
					let target = "other";

					// zkracene adresy poresime jinak
					if (url.pathname.match(/^\/s\//u)) {
						var xhr = new XMLHttpRequest();
						xhr.open('GET', action.args.url, true);
						xhr.onload = () => {
							promiseData.resolve({
								type: "url"
							});

							const finalUrl = new URL(xhr.responseURL);
							if (url.searchParams.has("planovani-trasy")) {
								target = "route";
							} else if (url.searchParams.has("q")) {
								target = "search";
							} else if (url.searchParams.has("source") && url.searchParams.has("id")) {
								target = "detail";
							}
							if (this._loggerData) {
								this.setLoggerData(undefined, search);
								this._loggerData.target = target;

								if (!this._fromTips && (this._loggerData.exact || action) && !mapSearch) {
									logSearchSelection(query, search, this._loggerData, opts.detailSearch);
								} else {
									this._fromTips = false;
								}
							}

							window.history.replaceState({}, "", finalUrl.pathname + finalUrl.search);
							Mapy.getComponent("history").getJakHistory2().getHistory().checkUrl();
						};
						xhr.onerror = () => {
							window.location = action.args.url;
						};
						xhr.send();
					} else {
						if (url.searchParams.has("planovani-trasy")) {
							target = "route";
						} else if (url.searchParams.has("q")) {
							target = "search";
						} else if (url.searchParams.has("source") && url.searchParams.has("id")) {
							target = "detail";
						}
						if (this._loggerData) {
							this.setLoggerData(undefined, search);
							this._loggerData.target = target;

							if (!this._fromTips && (this._loggerData.exact || action) && !mapSearch) {
								logSearchSelection(query, search, this._loggerData, opts.detailSearch);
							} else {
								this._fromTips = false;
							}
						}
						promiseData.resolve({
							type: "url"
						});
						window.history.replaceState({}, "", url.pathname + url.search);
						Mapy.getComponent("history").getJakHistory2().getHistory().checkUrl();
					}

				// asi jsme v IE11, nebo proste nekde, kde neni URL implementovana, tak jen slepe presmerujeme
				} catch (ex) {
					window.location = action.args.url;
				}
				break;
			case "detail":
				let id = action.args.id;
				let resultData = allResults[action.args.index];

				if (action.args.source === "coor" && allResults && allResults.length && allResults[action.args.index]) {
					let coords = allResults[action.args.index].coords;
					id = coords.toWGS84().join(",");
				}

				if (id !== 0 && (!isDetailActive(store.getState()) || opts.detailSearch) && !this._mapSearch) {
					const searchMeta = search.getMeta();
					const bbox = searchMeta.queryLoc?.bbox;
					wasHandled = true;

					if (this._loggerData) {
						this.setLoggerData(undefined, search);

						if (!this._fromTips && (this._loggerData.exact || action) && !mapSearch) {
							logSearchSelection(query, search, this._loggerData, opts.detailSearch);
						} else {
							this._fromTips = false;
						}
					}

					if (bbox) {
						const cz = Scene.computeCenterZoom([
							Scene.coordsFromWGS84(bbox.leftLon, bbox.leftLat),
							Scene.coordsFromWGS84(bbox.rightLon, bbox.rightLat)
						], false, parseInt(Mapy.CUS.search?.searchLocationBBoxTolerance) || 0);

						this.disablePanelLoad = true;
						cz[0] && cz[1] && this.rememberCenterZoom({
							center: cz[0],
							zoom: cz[1],
						});
					}

					if (resultData?.resultType && ["entity", "point"].indexOf(resultData.resultType) > -1 && resultData.mmsource === "dim") {
						Mapy.getComponent("dimcurator").setState({
							dim: resultData.mmid,
							search: {
								query: this._query,
								hasResults: this.hasResults(),
							},
						}).loadData().finally(() => {
							promiseData.resolve({
								type: "detail"
							});

							const { user } = store.getState().user;

							saveHistory(user, {
								title: this.getQuery().trim(),
								source: "web",
								type: "query",
							}).then(() => {}, () => {});

							Mapy.getComponent("history").save();
						});
					}
					else {
						this._listenToOverlayItems();

						const filtersData = search.getFilters();
						const hasBackArrow = (filtersData || []).filter(item => item.type === "back-arrow").length === 1;

						Mapy.getComponent("detail").setState({
							source: action.args.source,
							id,
							show: true,
							search: {
								query: this.getQuery().trim(),
								hasResults: allResults.length > 1 || hasBackArrow,
								exact: true,
							}
						}).then(() => {
							promiseData.resolve({
								type: "detail"
							});

							const storeState = store.getState();
							const user = storeState.user.user;
							const detailData = storeState.detail.data;

							if (action.args.source !== "coor") {
								// FIXME: jak se muze stat, ze data nejsou?
								if (detailData) {
									Mapy.getComponent("pois").forceRequest();

									Mapy.getComponent("history").save(true);
									this._listenToOverlayItems(true);

									saveHistory(user, {
										title: detailData.title,
										source: "web",
										type: "poi",
										data: {
											entitySource: detailData.source,
											entityId: detailData.id,
											lat: detailData.mark.lat,
											lon: detailData.mark.lon,
										},
									}).then(() => {}, () => {});
								}
							}
							else {
								saveHistory(user, {
									title: this.getQuery().trim(),
									source: "web",
									type: "query",
								}).then(() => {}, () => {});
							}
						}, e => {
							promiseData.resolve({
								type: "detail"
							});
						});
					}
				}
				break;

			case "premium":
				const user = store.getState().user.user;

				if (!user.premium) {
					promo.setAttribute("data-log-action", "searchPremium_premiumPurchase_show");
					openPropositionDialog("searchPremium");
				} else {
					Mapy.getComponent("premiumStatus").activate();
					Mapy.getComponent("history").save();
				}

				wasHandled = true;
				break;

			case "getLocation": {
				Mapy.getComponent("geolocation").openLocation();
				wasHandled = true;
				break;
			}
		}

		return wasHandled;
	}

	_clearSavedCorrection() {
		this._savedCorrection = {
			correctedQuery: "",
			correctorId: 0,
			items: [],
			shouldQuery: "",
			status: "nocorr",
		};
	}

	/**
	 * Vraci objekt s nody, ktere se maji pouzit pro tisk
	 */
	getPrintNodes() {
		var panel = node("div", { id: "search" });

		if (this._search) {
			// titulek
			var title = node("p", { innerHTML: _("search.printTitle") + ": <strong>" + this._query + "</strong>" });

			// panel
			var results = node("div", { id: "search-results" });
			var ul = node("ul");
			panel.appendChild(results);
			results.appendChild(ul);

			var from = Mapy.Search.PAGE * this._search.getPage();
			this._search.getResults().filter(function(poi) {
				return poi.ready;
			}).forEach(function(poi, index) {
				var item = new PrintItem(poi, from + index);
				ul.appendChild(item.getContainer());
			});

			return {
				title: title,
				panel: panel
			}
		} else {
			return {
				title: null,
				panel: panel
			}
		}
	}

	_markHaveResults(results) {
		setSaturation(results && Mapy.active[0] == this);
	}
};

Mapy.Search.PAGE = 15;
Mapy.Search.LOGGERCONST = {
	HASGEO: 1,
	HASSERVICE: 2,
	DELETEDFROMBACK: 4
};

Mapy.Search.SHOW_RESULTS_SOURCES = ["base", "traf", "di", "firm", "addr", "osmp"];
Mapy.Search.hideResults = function() {
	const { data } = store.getState().detail;

	if (data) {
		const source = data ? (data.source === "osm" ? data.origin : data.source) : null;

		return source && Mapy.Search.SHOW_RESULTS_SOURCES.indexOf(source) === -1;
	} else {
		return true;
	}
};
